import { render, staticRenderFns } from "./SearchClassifiersItem.vue?vue&type=template&id=aec5e60a&"
import script from "./SearchClassifiersItem.vue?vue&type=script&lang=js&"
export * from "./SearchClassifiersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports